import { medicalAssistantsRouteStore } from '../domain/store';

import { listMedicalAssistants } from './index';

export default (number) => {
  medicalAssistantsRouteStore.setValue('currentPage', number);
  return listMedicalAssistants();
};
